export default "__VITE_ASSET__D4Kq$H$Y__"